module.exports = __webpack_public_path__ + "static/media/pre-assembleia.b46635ed.png";